import { useMemo } from 'react';
import { readSidecarConfig } from '../../services/oidc/sidecar-config';
import { getAppConfig } from './app-config';

const sidecarConfig = readSidecarConfig();

export function useAppConfig() {
  const url = new URL(window.location.href);

  const protocolAndHost = `${url.protocol}//${url.host}`;

  return useMemo(() => {
    const config = getAppConfig(protocolAndHost, sidecarConfig);

    return config;
  }, [protocolAndHost]);
}
